import { render, staticRenderFns } from "./IconFolder.vue?vue&type=template&id=1e1e6834&"
import script from "./IconFolder.vue?vue&type=script&lang=js&"
export * from "./IconFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1e6834')) {
      api.createRecord('1e1e6834', component.options)
    } else {
      api.reload('1e1e6834', component.options)
    }
    module.hot.accept("./IconFolder.vue?vue&type=template&id=1e1e6834&", function () {
      api.rerender('1e1e6834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFolder.vue"
export default component.exports